import { useState, useLayoutEffect } from 'react';

export enum Breakpoint {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

const FALLBACK_BREAKPOINTS: Record<Breakpoint, number> = {
  [Breakpoint.XS]: 320,
  [Breakpoint.SM]: 480,
  [Breakpoint.MD]: 768,
  [Breakpoint.LG]: 1024,
  [Breakpoint.XL]: 1280,
};

export const useIsBreakpoint = (breakpoint: Breakpoint = Breakpoint.LG): boolean => {
  const [isBreakpoint, setIsBreakpoint] = useState(false);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      const styles = getComputedStyle(document.documentElement);
      const cssValue = styles.getPropertyValue(`--breakpoint-${breakpoint}`).trim();
      const parsedRem = parseFloat(cssValue.replace('rem', ''));
      const targetBreakpoint = !isNaN(parsedRem) ? parsedRem * 16 : FALLBACK_BREAKPOINTS[breakpoint];

      setIsBreakpoint(window.innerWidth < targetBreakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isBreakpoint;
};
